import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import pinia from './qingyu/store/pinia'

// 导入Element Plus
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
// 导入自定义主题样式（必须在导入Element Plus样式之后）
import './assets/styles/element-theme.scss'
// 导入中文语言包
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'

// 导入qingyu框架
import qingyu from './qingyu'

const app = createApp(App)

// 使用插件 (顺序很重要)
// 1. 先初始化pinia
app.use(pinia)
// 2. 再使用其他插件
app.use(router)
app.use(qingyu)
// 3. 最后注册UI组件库
app.use(ElementPlus, {
  locale: zhCn,
  // 设置组件默认尺寸
  size: 'default',
  // 设置按钮默认为圆角
  zIndex: 3000
})

app.mount('#app')
